import { render, staticRenderFns } from "./changeproduct.vue?vue&type=template&id=518d88e6"
import script from "./changeproduct.vue?vue&type=script&lang=js"
export * from "./changeproduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports